module.exports = __webpack_public_path__ + "img/la.265bf577.jpg";